export const TICK_DURATION = 1000 / 60;
export const MAX_CATCHUP_TICKS = 5;

/**
 * Advance one animation frame. `elapsedMs` is wall-clock time since the last
 * frame (including time spent in a background tab). The day/night clock uses
 * that full span; physics still runs on a clamped fixed-step accumulator.
 */
export function stepFrame(game, elapsedMs, accumulator) {
  game.advanceClock?.(elapsedMs / 1000);

  const dt = TICK_DURATION / 1000;
  let acc = accumulator + elapsedMs;
  const maxAccum = TICK_DURATION * MAX_CATCHUP_TICKS;
  // Compare against the tick count, not `maxAccum` leftover — `n * (1000/60)`
  // is not guaranteed to stay `>= TICK_DURATION` after n-1 subtractions.
  if (acc >= maxAccum) {
    for (let i = 0; i < MAX_CATCHUP_TICKS; i++) game.update(dt);
    game.render();
    return 0;
  }
  while (acc >= TICK_DURATION) {
    game.update(dt);
    acc -= TICK_DURATION;
  }

  game.render();
  return acc;
}

export function startLoop(game) {
  let lastTimestamp = null;
  let accumulator = 0;

  function gameLoop(timestamp) {
    if (lastTimestamp === null) lastTimestamp = timestamp;
    const elapsed = timestamp - lastTimestamp;
    lastTimestamp = timestamp;
    accumulator = stepFrame(game, elapsed, accumulator);
    requestAnimationFrame(gameLoop);
  }

  requestAnimationFrame(gameLoop);
}
